(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-experts-gallery"] && !Shopify.designMode) return;
  try {
    

  // Listen for click on the document
            document.addEventListener('click', function (event) {

              //Bail if our clicked element doesn't have the class
              if (!event.target.classList.contains('accordion-toggle')) return;

              // Get the target content
              var content = document.querySelector(event.target.hash);
              var trigger = event.target;
              if (!content) return;

              // Prevent default link behavior
              event.preventDefault();

              // If the content is already expanded, collapse it and quit
              // if (content.classList.contains('active')) {
              //   content.classList.remove('active');
              //   return;
              // }

              // Get all open accordion content, loop through it, and close it
              var accordions = document.querySelectorAll('.accordion-content.active');
              var triggers = document.querySelectorAll('.thumbnail-toggle.active');
              for (var i = 0; i < accordions.length; i++) {
                accordions[i].classList.remove('active');
                // triggers[i].classList.remove('active');
              }

              // Toggle our content
              content.classList.toggle('active');
               // trigger.classList.toggle('active');
            })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let PDFBtn = document.querySelector('.PDF__btn');
    var triggerButton = document.getElementById('ingredientsPopupTrigger');
    var popup = document.getElementById('ingredientsPopup');
    var body = document.getElementById('Body');
    let closeBtn = document.querySelector('.close__btn');

    // let pdfUrl =PDFBtn.id ;

    // PDFBtn.addEventListener('click', function() {
    //   window.open(pdfUrl, '_blank');
    // });
    if (triggerButton)
      triggerButton.addEventListener('click', function () {
        body.classList.add('ingredients-popup-open');
      });
    if (closeBtn)
      closeBtn.addEventListener('click', function () {
        body.classList.remove('ingredients-popup-open');
      });
    if (popup)
      popup.addEventListener('click', function () {
        body.classList.remove('ingredients-popup-open');
      });
  });

  var isAnimating = false;

  function scrollLeftAnimate(elem, unit) {
    if (!elem || isAnimating) {
      //if element not found / if animating, do not execute slide
      return;
    }

    var time = 300; // animation duration in MS, the smaller the faster.
    var from = elem.scrollLeft; // to continue the frame posistion
    var aframe = 10; //fraction of frame frequency , set 1 for smoothest  ~ set 10++ for lower FPS (reduce CPU usage)
    isAnimating = true; //if animating prevent double trigger animation

    var start = new Date().getTime(),
      timer = setInterval(function () {
        var step = Math.min(1, (new Date().getTime() - start) / time);
        elem.scrollLeft = step * unit + from;
        if (step === 1) {
          clearInterval(timer);
          isAnimating = false;
        }
      }, aframe);
  }

  function initDealCarrousel(dealCarrouselID) {
    var target = document.querySelector('#' + dealCarrouselID + ' .carrousel-flexbox');
    var cardOutterWidth;
    var maxCarrouselScroll;
    let touchstartX = 0;
    let touchendX = 0;

    function updateUpaCarrouselInfo() {
      cardOutterWidth = document.querySelector('#' + dealCarrouselID + ' .card').offsetWidth; //you can define how far the scroll
      maxCarrouselScroll =
        document.querySelectorAll('#' + dealCarrouselID + ' .card').length * cardOutterWidth -
        document.querySelector('#' + dealCarrouselID + ' .carrousel-flexbox').clientWidth;
    }

    const scrollLeftElement = document.querySelector('#' + dealCarrouselID + ' .deals-scroll-left');
    if (scrollLeftElement) {
      scrollLeftElement.addEventListener('click', function () {
        updateUpaCarrouselInfo(); //in case window resized, will get new info
        if (target.scrollLeft > 0) {
          scrollLeftAnimate(target, -cardOutterWidth * 1);
        }
      });
    }

    const scrollRightElement = document.querySelector('#' + dealCarrouselID + ' .deals-scroll-right');
    if (scrollRightElement) {
      scrollRightElement.addEventListener('click', function () {
        updateUpaCarrouselInfo(); //in case window resized, will get new info
        if (target.scrollLeft < maxCarrouselScroll) {
          scrollLeftAnimate(target, cardOutterWidth * 1);
        }
      });
    }

    // function checkDirection() {
    // 	  if (touchendX < touchstartX) {
    // 		  if (target.scrollLeft < maxCarrouselScroll) {
    // 				scrollLeftAnimate(target, cardOutterWidth * 1);
    // 			}
    // 	  };
    // 	  if (touchendX > touchstartX) {
    // 	  	if (target.scrollLeft > 0) {
    //                scrollLeftAnimate(target, -cardOutterWidth * 1);
    //            }
    // 	  };
    // 	}

    // document.addEventListener('touchstart', e => {
    //   touchstartX = e.changedTouches[0].screenX
    // })

    // document.addEventListener('touchend', e => {
    //   touchendX = e.changedTouches[0].screenX
    //   checkDirection()
    // })
  }
  // Initiate the container with ID
  initDealCarrousel('carousel'); //carrousel ID

  // Open the Modal
  function openModal() {
    document.getElementById('myModal').style.display = 'block';
  }
  // Close the Modal
  function closeModal() {
    document.getElementById('myModal').style.display = 'none';
  }
  var slideIndex = 1;
  showSlides(slideIndex);
  // Next/previous controls
  function plusSlides(n) {
    showSlides((slideIndex += n));
  }
  // Thumbnail image controls
  function currentSlide(n) {
    showSlides((slideIndex = n));
  }

  function showSlides(n) {
    var i;
    var slides = document.getElementsByClassName('mySlides');

    // Safety check: if no slides exist, exit early
    if (slides.length === 0) {
      return;
    }

    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';
    }

    slides[slideIndex - 1].style.display = 'block';

    if (slides[slideIndex - 1].hasAttribute('data-src')) {
      slides[slideIndex - 1].setAttribute('src', slides[slideIndex - 1].getAttribute('data-src'));
      slides[slideIndex - 1].removeAttribute('data-src');
      slides[slideIndex - 1].classList.add('fadein');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logo-slider"] && !Shopify.designMode) return;
  try {
    
  var isAnimating = false;

  function scrollLeftAnimate(elem, unit) {
    if (!elem || isAnimating) {
      //if element not found / if animating, do not execute slide
      return;
    }

    var time = 300; // animation duration in MS, the smaller the faster.
    var from = elem.scrollLeft; // to continue the frame posistion
    var aframe = 10; //fraction of frame frequency , set 1 for smoothest  ~ set 10++ for lower FPS (reduce CPU usage)
    isAnimating = true; //if animating prevent double trigger animation

    var start = new Date().getTime(),
      timer = setInterval(function () {
        var step = Math.min(1, (new Date().getTime() - start) / time);
        elem.scrollLeft = step * unit + from;
        if (step === 1) {
          clearInterval(timer);
          isAnimating = false;
        }
      }, aframe);
  }

  function initDealCarrousel(dealCarrouselID) {
    var target = document.querySelector('#' + dealCarrouselID + ' .carrousel-flexbox');
    var cardOutterWidth;
    var maxCarrouselScroll;
    let touchstartX = 0;
    let touchendX = 0;

    function updateUpaCarrouselInfo() {
      cardOutterWidth = document.querySelector('#' + dealCarrouselID + ' .card').offsetWidth; //you can define how far the scroll
      maxCarrouselScroll =
        document.querySelectorAll('#' + dealCarrouselID + ' .card').length * cardOutterWidth -
        document.querySelector('#' + dealCarrouselID + ' .carrousel-flexbox').clientWidth;
    }

    const scrollLeftElement = document.querySelector('#' + dealCarrouselID + ' .deals-scroll-left');
    if (scrollLeftElement) {
      scrollLeftElement.addEventListener('click', function () {
        updateUpaCarrouselInfo(); //in case window resized, will get new info
        if (target.scrollLeft > 0) {
          scrollLeftAnimate(target, -cardOutterWidth * 1);
        }
      });
    }

    const scrollRightElement = document.querySelector('#' + dealCarrouselID + ' .deals-scroll-right');
    if (scrollRightElement) {
      scrollRightElement.addEventListener('click', function () {
        updateUpaCarrouselInfo(); //in case window resized, will get new info
        if (target.scrollLeft < maxCarrouselScroll) {
          scrollLeftAnimate(target, cardOutterWidth * 1);
        }
      });
    }

    function checkDirection() {
      if (touchendX < touchstartX) {
        if (target.scrollLeft < maxCarrouselScroll) {
          scrollLeftAnimate(target, cardOutterWidth * 1);
        }
      }
      if (touchendX > touchstartX) {
        if (target.scrollLeft > 0) {
          scrollLeftAnimate(target, -cardOutterWidth * 1);
        }
      }
    }

    document.addEventListener('touchstart', (e) => {
      touchstartX = e.changedTouches[0].screenX;
    });

    document.addEventListener('touchend', (e) => {
      touchendX = e.changedTouches[0].screenX;
      checkDirection();
    });
  }
  // Initiate the container with ID
  initDealCarrousel('carousel'); //carrousel ID

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-list"] && !Shopify.designMode) return;
  try {
    
  // Initialize slider functionality when the DOM is loaded
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId === '{{ section.id }}') {
        window.dispatchEvent(new Event('resize'));

        // Ensure equal height of all slides
        const slides = document.querySelectorAll('#Slider-{{ section.id }} .slider__slide');
        if (slides.length) {
          // Reset heights
          slides.forEach((slide) => {
            slide.style.height = 'auto';
          });

          // Set equal height after a short delay to ensure content is rendered
          setTimeout(() => {
            let maxHeight = 0;
            slides.forEach((slide) => {
              maxHeight = Math.max(maxHeight, slide.offsetHeight);
            });

            if (maxHeight > 0) {
              slides.forEach((slide) => {
                slide.style.height = maxHeight + 'px';
              });
            }
          }, 100);
        }
      }
    });

    // Also run on window resize
    window.addEventListener('resize', function () {
      if (document.querySelector('#Slider-{{ section.id }}')) {
        const slides = document.querySelectorAll('#Slider-{{ section.id }} .slider__slide');
        if (slides.length) {
          // Reset heights
          slides.forEach((slide) => {
            slide.style.height = 'auto';
          });

          // Set equal height after a short delay
          setTimeout(() => {
            let maxHeight = 0;
            slides.forEach((slide) => {
              maxHeight = Math.max(maxHeight, slide.offsetHeight);
            });

            if (maxHeight > 0) {
              slides.forEach((slide) => {
                slide.style.height = maxHeight + 'px';
              });
            }
          }, 100);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
